// dhtmlxgantt (v8, likely v9) reads window.navigator.pointerEnabled/msPointerEnabled
if (!window.navigator) {
  window.navigator = {
    pointerEnabled: false,
    msPointerEnabled: false,
  };
} else {
  if (window.navigator.pointerEnabled === undefined) {
    window.navigator.pointerEnabled = false;
  }
  if (window.navigator.msPointerEnabled === undefined) {
    window.navigator.msPointerEnabled = false;
  }
}
